import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router';

import { requireRole } from '@/helpers/permissions';
import CouponForm from '@/components/CouponForm';
import Page from '@/pages/Page';

export default requireRole(['owner', 'manager'], EditCouponPage);

function EditCouponPage() {
  const {uuid:id} = useParams();
  const history = useHistory();
  const coupon = useSelector((store) => _.find(store.coupons, {id}));

  const goToIndex = () => history.push('/coupons');

  return (
    <Page title="Edit Coupon" backDefault="/coupons">
      <CouponForm coupon={coupon} done={goToIndex}/>
    </Page>
  );
}
